import { render } from "./GraphsOneOrMore.vue?vue&type=template&id=2e1029f1"
import script from "./GraphsOneOrMore.vue?vue&type=script&lang=js"
export * from "./GraphsOneOrMore.vue?vue&type=script&lang=js"
script.render = render

export default script